import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';

var SemanticModal = function SemanticModal(_ref) {
  var _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      children = _ref.children,
      trigger = _ref.trigger;
  return React.createElement(Modal, {
    content: children,
    forceIsShowing: open,
    onClose: onClose,
    onOpen: onOpen
  }, function (_ref2) {
    var handleClick = _ref2.open;
    return cloneElement(trigger, {
      onClick: handleClick
    });
  });
};

export default SemanticModal;
SemanticModal.propTypes = {
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.node,
  trigger: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};
SemanticModal.defaultProps = {
  open: undefined,
  onOpen: undefined,
  onClose: undefined,
  children: undefined,
  trigger: undefined
};